"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _crmApi = require("@ys/crm-api");
var _FilePreview = _interopRequireDefault(require("@/components/FilePreview.vue"));
var _CommentAdd = _interopRequireDefault(require("./CommentAdd.vue"));
var _default = exports.default = {
  name: 'Comment',
  components: {
    CommentAdd: _CommentAdd.default,
    FilePreview: _FilePreview.default
  },
  props: {
    assId: {
      type: String,
      required: true
    },
    assType: {
      type: Number,
      required: true
    },
    pageSize: {
      type: [String, Number],
      default: 5
    },
    showAdd: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      commentVisible: false,
      page: {
        pageNo: 1,
        total: 0
      },
      commentList: []
    };
  },
  mounted() {
    this.getCommentList();
  },
  methods: {
    async getCommentList() {
      const page = this.page;
      const res = (await _crmApi.YcAreaConfigService.getCommentList({
        query: {
          assId: this.assId,
          pageSize: this.pageSize,
          pageNo: page.pageNo
        }
      })).data.data;
      page.total = res.total;
      this.commentList = res.records;
    },
    getCommentTitle(comment) {
      if (!comment.parentUserName) {
        return comment.operateUserName;
      }
      return `${comment.operateUserName} 回复 ${comment.parentUserName}`;
    },
    handleCommentAdd({
      id,
      operateUser,
      operateUserName
    } = {}) {
      if (!this.showAdd) {
        return;
      }
      this.$refs.commentAdd.add({
        parentId: id,
        parentUser: operateUser,
        parentUserName: operateUserName
      });
    }
  }
};